import * as ERROR_CONSTANTS from './error'
export namespace Constants {
    export const AUTHENTICATE = 'authenticate'
    export const BETA_RESTRICTED =
        'This app is currently in beta and is only available to a select group of users.'
    export const APP_RESTRICTED =
        'This app is currently is only available to a select group of registered users.'
    export const APP_RESTRICTED_ADDITIONAL_1 =
        'If you are using a myDevice and normally have access to this page, please try relaunching the MPM app by opening '
    export const APP_RESTRICTED_ADDITIONAL_2 =
        'your recent apps (square button), swipe the app up or down to quit, and then relaunch MPM.'
    export const APP_RESTRICTED_ACTION =
        'If these steps do not resolve the issue, please use the feedback feature below to let us know.'
    export const LOGIN_FAIL = 'failed to log in'
    export const LOGIN_SUCCESSFUL = 'successfully logged in'
    export const ERROR = ERROR_CONSTANTS
    // use with REACT_APP_ENV to put the app in a mocked auth state
    export const FAKE_AUTH = 'fakeauth'
    export const APP_ID = 'mpm'
    export const GREENFIELD_CARDS = {
        SALES: {
            LOCATION_INTRADAY: '2401476',
            LOCATION_HISTORICAL: '2426812',
            HOURLY: '2463865',
            BASKET_HISTORICAL: '3069668',
        },
        LOYALTY: {
            LOYALTY_OVERVIEW_RGD: '829436',
            LOYALTY_OVERVIEW_STORE: '829439',
            TARGET_CIRCLE_360: '2565070',
        },
        ASSETS_PROTECTION: {
            SECURE: '3248940',
            THEFT_INTERNAL: '3248830',
            THEFT_EXTERNAL: '3261409',
            PAYROLL_RGD: '1751764',
        },
        BRANDS: {
            BRAND_CLASS: '756031',
            BRAND_ITEM: '756030',
            BRAND_METRICS: '756032',
            BRAND_LOCATIONS: '2727674',
            BRAND_ULTA_LOYALTY: '1887336',
        },
        FULFILLMENT: {
            HISTORICAL_PICKUP: '2865252',
            HISTORICAL_SHIP: '2915588',
            SHIP_ON_TIME: '3547849',
            NDD_HISTORICAL: '2939069',
        },
        SAFETY: {
            // STORE_LAGGING: '99683',
            STORE_LAGGING: '3226476',
            STORE_TOTAL: '396666',
            STORE_LEADING: '100598',
            LAGGING_COMPANY: '3302481',
            LAGGING_REGION: '3304123',
            LAGGING_GROUP: '3304116',
            LAGGING_DISTRICT: '3302488',
            LAGGING_STORE: '3314865',
        },
        MY_TARGET_PERFORMANCE: {
            GUEST_METRICS: '3230656',
            GUEST_GOALS: '3254424',
            FINANCIAL_METRICS: '3269181',
            FINANCIAL_GOALS: '3270661',
            TEAM_METRICS: '3269183',
            TEAM_GOALS: '3270777',
            GREEN_STORES_COMPANY: '3343032',
            GREEN_STORES_REGION: '3328319',
            GREEN_STORES_GROUP: '3343020',
            GREEN_STORES_DISTRICT: '3343060',
        },
        PAYROLL: {
            LOCATION_MONTHLY: '3232186',
            LOCATION_WEEKLY: '532905',
            LOCATION_DAILY: '539882',
        },
    }
    // Named greenfield groups to follow convention in the user details API, but ultimately user details is consuming Acorn roles
    export const GREENFIELD_GROUPS = {
        ASSETS_PROTECTION: 'MPM-ASSETS-PROTECTION',
        PAYROLL: 'MPM-PAYROLL',
        SALES_LOCATION: 'MPM-SALES-LOCATION',
        ADMIN_PROD: 'APP-OAUTH2-MPM-ADMIN-PROD',
        NOTES_READ_ACROSS_LOCATIONS: 'MPM-NOTES-READ-ACROSS-LOCATIONS',
        NOTES_READ_SAME_LOCATION: 'MPM-NOTES-READ-SAME-LOCATION',
        NOTES_WRITE: 'MPM-NOTES-WRITE',
        ALPHA_TESTERS: 'APP-MPM-ALPHA-TESTERS',
        BETA: 'APP-MPM2-Beta-Poweruser',
        POWERUSER: 'APP-MPM2-Poweruser',
    }
    export const TIME_PERIOD_KEYS = {
        TODAY: 'TODAY',
        YESTERDAY: 'YESTERDAY',
        WEEK_TO_DAY: 'WEEK_TO_DAY',
        LAST_WEEK: 'LAST_WEEK',
        MONTH_TO_DAY: 'MONTH_TO_DAY',
        YEAR_TO_DAY: 'YEAR_TO_DAY',
    } as const

    export const TIME_DIMENSION_HISTORICAL_GF_ARRAY = [
        'yesterday',
        'week_to_day',
        'last_week',
        'month_to_day',
        'prior_month',
        'year_to_day',
    ] as const
}

export const HttpStatus = {
    NO_CONTENT: 204,
}

export const MethodConstants = {
    GET: 'GET' as const,
    POST: 'POST' as const,
    PUT: 'PUT' as const,
    PATCH: 'PATCH' as const,
    DELETE: 'DELETE' as const,
}
